// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content_Oz59P {
  position : absolute;
  top : 0;
  left : 0;
  right : 0;
  bottom : 0;
  overflow : hidden;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/dataViewers/responsive/ResponsiveView.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB","sourcesContent":[".content {\n  position : absolute;\n  top : 0;\n  left : 0;\n  right : 0;\n  bottom : 0;\n  overflow : hidden;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content_Oz59P`
};
export default ___CSS_LOADER_EXPORT___;
